<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descricao"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="descricao"
              >
                <b-form-input
                  id="descricao"
                  v-model="eventDiscount.descricao"
                  data-cy="input-descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Digite a descrição do desconto"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-descricao"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="evento"
              rules="required"
            >
              <b-form-group
                label="Evento"
                label-for="evento"
              >
                <v-select
                  id="evento"
                  v-model="eventDiscount.evento"
                  data-cy="select-evento"
                  :options="eventosCombo"
                  label="nome"
                  :reduce="(evento) => evento"
                  placeholder="Selecione o evento"
                  :disabled="!canEditOrInsert"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum evento encontrado
                    </div>
                  </template>
                </v-select>
                <small
                  data-cy="error-evento"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="tipo"
              rules="required"
            >
              <b-form-group
                label="Tipo"
                label-for="tipo"
              >
                <v-select
                  id="tipo"
                  v-model="eventDiscount.tipo"
                  data-cy="select-tipo"
                  :options="tiposCombo"
                  label="nome"
                  :reduce="(tipo) => tipo"
                  placeholder="Selecione o tipo"
                  :disabled="!canEditOrInsert"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum tipo encontrado
                    </div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="6">
            <validation-provider
              #default="{ errors }"
              name="tipoRegistro"
              rules="required"
            >
              <b-form-group
                label="Tipo de Registro"
                label-for="tipoRegistro"
              >
                <v-select
                  id="tipoRegistro"
                  v-model="eventDiscount.tipoRegistro"
                  data-cy="select-tipo-registro"
                  :options="tiposRegistroCombo"
                  label="nome"
                  :reduce="(tipo) => tipo"
                  placeholder="Selecione o tipo de registro"
                  :disabled="!canEditOrInsert"
                >
                  <template #no-options>
                    <div class="text-muted">
                      Nenhum tipo de registro encontrado
                    </div>
                  </template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="percentualDesconto"
              rules="required"
            >
              <b-form-group
                label="Percentual de Desconto"
                label-for="percentualDesconto"
              >
                <b-form-input
                  id="percentualDesconto"
                  v-model="eventDiscount.percentualDesconto"
                  data-cy="input-percentual"
                  type="number"
                  min="0"
                  max="100"
                  placeholder="0-100"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-percentual"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="3">
            <validation-provider
              #default="{ errors }"
              name="valorDesconto"
              rules="required"
            >
              <b-form-group
                label="Valor do Desconto"
                label-for="valorDesconto"
              >
                <money
                  id="valorDesconto"
                  v-model="eventDiscount.valorDesconto"
                  data-cy="input-valor"
                  v-bind="money"
                  class="form-control"
                  placeholder="0,00"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-valor"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-checkbox
              id="ativo"
              v-model="eventDiscount.ativo"
              data-cy="switch-ativo"
              name="ativo"
              switch
              :disabled="
                (!verificarPermissao('ROLE_EVENTOS_ATUALIZAR') &&
                  !!eventDiscount.id) ||
                  (!verificarPermissao('ROLE_EVENTOS_INSERIR') && !eventDiscount.id)
              "
            >
              {{ eventDiscount.ativo ? "Sim" : "Não" }}
            </b-form-checkbox>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_EVENTOS_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_EVENTOS_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import { Money } from 'v-money'
import mixinsGlobal from '@/mixins'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import Ripple from 'vue-ripple-directive'
import { verificarPermissao } from '@/auth/utils'

export default {
  name: 'EventDiscountForm',
  components: {
    Money,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Descontos de Evento',
      required,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      // These should be loaded from your API
      eventosCombo: [],
      tiposCombo: [],
      tiposRegistroCombo: [],
      loading: false,
    }
  },
  computed: {
    ...mapState('eventDiscountSettingsModule', {
      eventDiscount: state => state.eventDiscount,
    }),
    canEditOrInsert() {
      return (
        (!this.eventDiscount.id
          && this.verificarPermissao('ROLE_EVENTOS_INSERIR'))
        || (this.eventDiscount.id
          && this.verificarPermissao('ROLE_EVENTOS_ATUALIZAR'))
      )
    },
  },
  created() {
    this.loading = true
    this.loadDependencies()
  },
  methods: {
    async loadDependencies() {
      try {
        const queryParams = {
          page: 1, size: 1000, sort: 'nome', order: 'asc',
        }

        // Load Events
        this.$store.dispatch('eventSettingsModule/loadTable', queryParams)
          .then(result => {
            this.eventosCombo = result.data.content
          })

        // Load Types
        this.$store.dispatch('combosModule/loadComboTipoEvento')
          .then(result => {
            this.tiposCombo = result.data
          })

        // Load Registration Types
        this.$store.dispatch('combosModule/loadComboTypesRegister', 2)
          .then(result => {
            this.tiposRegistroCombo = result.data
          })

        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Error loading dependencies:', error)
      }
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          const action = this.eventDiscount.id ? 'edit' : 'insertNew'
          this.$store
            .dispatch(`eventDiscountSettingsModule/${action}`, this.eventDiscount)
            .then(response => {
              if (response.response) {
                this.MensagemError(
                  this.eventDiscount.id ? 'Falha ao Editar' : 'Falha ao Inserir',
                  response.response.data.error,
                )
                return
              }
              this.showMessageSuccess(
                this.eventDiscount.id ? 'Editar' : 'Salvo',
                this.eventDiscount.id
                  ? 'Editado com sucesso!'
                  : 'Incluído com sucesso!',
              )
              this.cancel()
            })
        }
      })
    },
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('eventDiscountSettingsModule/reset')
    },
    cleanObjeto() {
      this.$store.dispatch('eventDiscountSettingsModule/reset')
    },
  },
}
</script>
